import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonAdminRolesForm } from '../forms/PersonRolesForm';

type PersonAdminRolesModalProps = {
  personUuid: string;
  personName: string;
  isOpen: boolean;
  onClose: () => void;
};

export const PersonAdminRolesModal = ({ personUuid, personName, isOpen, onClose }: PersonAdminRolesModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={t('profiles.grantRolesTo', { name: personName })}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <PersonAdminRolesForm
        personUuid={personUuid}
        onLoad={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
